import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  simulatedTime: undefined,
  gps: undefined,
  overrideLocations: false,
  latitudeOffset: undefined,
  longitudeOffset: undefined,
};
